import React, { useState } from "react";

import Logo from "../images/logo.png";

import "../stylesheets/navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from "@fortawesome/free-solid-svg-icons";

import {
   MDBContainer,
   MDBNavbar,
   MDBNavbarBrand,
   MDBNavbarToggler,
   MDBNavbarNav,
   MDBNavbarItem,
   MDBNavbarLink,
   MDBCollapse
} from "mdb-react-ui-kit";

export default function Navbar() {
   const [showBasic, setShowBasic] = useState(false);

   return (
      <MDBContainer>
         <MDBNavbar expand="lg" light bgColor="white">
            <MDBNavbarBrand href="#">
               <img src={Logo} height="70" alt="Logo" />
            </MDBNavbarBrand>

            <MDBNavbarToggler
               aria-controls="navbarSupportedContent"
               aria-expanded="false"
               aria-label="Toggle navigation"
               onClick={() => setShowBasic(!showBasic)}
               className="me-5"
            >
               <FontAwesomeIcon icon={faBars} />
            </MDBNavbarToggler>
            <MDBCollapse navbar show={showBasic} className="navbar-ud">
               <MDBNavbarNav className="mr-auto mb-2 mb-lg-0">
                  <MDBNavbarItem>
                     <MDBNavbarLink className="ms-2" href="#">Home</MDBNavbarLink>
                  </MDBNavbarItem>
                  <MDBNavbarItem>
                     <MDBNavbarLink className="ms-2" href="#/jobcard">Create a Job Card</MDBNavbarLink>
                  </MDBNavbarItem>
                  <MDBNavbarItem>
                     <MDBNavbarLink className="ms-2" aria-current="page" href="#">Search for a Job Card</MDBNavbarLink>
                  </MDBNavbarItem>
                  <MDBNavbarItem>
                     <MDBNavbarLink className="ms-2" active aria-current="page" href="#/authentication">Admin</MDBNavbarLink>
                  </MDBNavbarItem>
               </MDBNavbarNav>
            </MDBCollapse>
         </MDBNavbar>
      </MDBContainer>
   );
}
